/* tslint:disable */
/* eslint-disable */
/**
 * Контроль місій для FPV
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface OutputUavMissionsReportItem
 */
export interface OutputUavMissionsReportItem {
    /**
     * 
     * @type {number}
     * @memberof OutputUavMissionsReportItem
     */
    flights: number;
    /**
     * 
     * @type {number}
     * @memberof OutputUavMissionsReportItem
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof OutputUavMissionsReportItem
     */
    name: string;
    /**
     * 
     * @type {number}
     * @memberof OutputUavMissionsReportItem
     */
    shootdowns: number;
}

/**
 * Check if a given object implements the OutputUavMissionsReportItem interface.
 */
export function instanceOfOutputUavMissionsReportItem(value: object): boolean {
    if (!('flights' in value)) return false;
    if (!('name' in value)) return false;
    if (!('shootdowns' in value)) return false;
    return true;
}

export function OutputUavMissionsReportItemFromJSON(json: any): OutputUavMissionsReportItem {
    return OutputUavMissionsReportItemFromJSONTyped(json, false);
}

export function OutputUavMissionsReportItemFromJSONTyped(json: any, ignoreDiscriminator: boolean): OutputUavMissionsReportItem {
    if (json == null) {
        return json;
    }
    return {
        
        'flights': json['flights'],
        'id': json['id'] == null ? undefined : json['id'],
        'name': json['name'],
        'shootdowns': json['shootdowns'],
    };
}

export function OutputUavMissionsReportItemToJSON(value?: OutputUavMissionsReportItem | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'flights': value['flights'],
        'id': value['id'],
        'name': value['name'],
        'shootdowns': value['shootdowns'],
    };
}

